export const LONG_VIDEO_DURATION = 30;
